import AnimatedSection from '../common/AnimatedSection'
import { contactMapSection } from '../../data/contactPageData'

function ContactMapSection() {
  const { titleLine1, titleAccent, mapTitle, mapAddress, mapEmbedUrl, mapLink } =
    contactMapSection

  return (
    <AnimatedSection className="contact-map">
      <div className="container corp-container">
        <header className="contact-map__head">
          <h2>
            {titleLine1} <span>{titleAccent}</span>
          </h2>
          <span className="contact-map__accent" aria-hidden="true" />
        </header>

        <div className="contact-map__frame">
          <iframe
            title={`${mapTitle} location map`}
            src={mapEmbedUrl}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>

        <p className="contact-map__caption">
          <strong>{mapTitle}</strong>
          <span>{mapAddress}</span>
          <a href={mapLink} target="_blank" rel="noopener noreferrer">
            View larger map
          </a>
        </p>
      </div>
    </AnimatedSection>
  )
}

export default ContactMapSection
